export default "__VITE_ASSET__CTX9L7ih__"